export const useScrollToElement = (id: string) => {
  const scrollToElement = () => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return scrollToElement;
};
